import Rest from '../../Rest'

export default class ReportingChannelConfigService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/reporting_channel_config'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

}
